import { MenuItemKey } from "../../Layout/Sidebar/MenuItemKey";
import { IRoute } from "./Routes";
import ListRoles from "../../../Pages/Admin/Roles/List/ListRoles";
import ListUsers from "../../../Pages/Admin/Users/List/ListUsers";
import ListIdentityProviders from "../../../Pages/Admin/IdentityProviders/List/ListIdentityProviders";
import EditIdentityProvider from "../../../Pages/Admin/IdentityProviders/Edit/EditIdentityProvider";
import EditRole from "../../../Pages/Admin/Roles/Edit/EditRole";
import EditUser from "../../../Pages/Admin/Users/Edit/EditUser";
import ListFiles from "../../../Pages/Admin/Files/List/ListFiles";
import AdminCreateManyDelegates from "../../../Pages/Admin/Delegates/CreateMany/CreateManyDelegates";
import NodesTreeView from "../../../Pages/Admin/Nodes/TreeView/NodesTreeView";
import ListSolutions from "../../../Pages/Admin/Solutions/List/ListSolutions";
import EditSolution from "../../../Pages/Admin/Solutions/Edit/EditSolution";
import ListTenancies from "../../../Pages/Admin/Tenancies/List/ListTenancies";
import EditTenancy from "../../../Pages/Admin/Tenancies/Edit/EditTenancy";
import EditOntology from "../../../Pages/Admin/Ontologies/Edit/EditOntology";
import ListOntologies from "../../../Pages/Admin/Ontologies/List/ListOntologies";
import Home from "../../../Pages/Admin/Shared/Home/Home";
import ListPackages from "../../../Pages/Admin/Packages/List/ListPackages";
import EditPackage from "../../../Pages/Admin/Packages/Edit/EditPackage";
import ListRelationships from "../../../Pages/Admin/Relationships/List/ListRelationships";
import EditRelationship from "../../../Pages/Admin/Relationships/Edit/EditRelationship";
import ListVirtualTreeViews from "../../../Pages/Admin/VirtualTreeViews/List/ListVirtualTreeViews";
import EditVirtualTreeViews from "../../../Pages/Admin/VirtualTreeViews/Edit/EditVirtualTreeViews";
import Root from "../../../Pages/Admin/Shared/Root/Root";
import ListDataHubCredentials from "../../../Pages/Admin/DataHubCredentials/List/ListDataHubCredentials";
import EditDataHubCredentials from "../../../Pages/Admin/DataHubCredentials/Edit/EditDataHubCredentials";
import ListDataHubPublishers from "../../../Pages/Admin/DataHubPublishers/List/ListDataHubPublishers";
import EditDataHubPublishers from "../../../Pages/Admin/DataHubPublishers/Edit/EditDataHubPublisher";
import EditNode, { IProps as IEditNodeProps } from "../../../Pages/Admin/Nodes/Edit/EditNode";
import ViewSolutionEnablement from "../../../Pages/Admin/Solutions/Enablement/ViewSolutionEnablement";
import EditDataPoint from "../../../Pages/Admin/DataPoints/Edit/EditDataPoint";
import EditEntity from "../../../Pages/Admin/Entities/Edit/EditEntity";
import EditAttribute from "../../../Pages/Admin/Attributes/Edit/EditAttribute";
import NodesGraphView from "../../../Pages/Admin/Nodes/GraphView/NodesGraphView";

export default class AdminRoutes
{
    public routes: IRoute<any>[] = [
        {
            requiredRights: [],
            path: "/",
            component: Root
        },
        {
            requiredRights: [
                "ADMINPORTAL.Home.Landing"
            ],
            path: "/admin/home",
            component: Home,
            menuItemId: MenuItemKey.Admin_Home
        },
        {
            requiredRights: [
                "ADMINPORTAL.IdentityProviders.Setup"
            ],
            path: "/security-identity-providers",
            component: ListIdentityProviders,
            menuItemId: MenuItemKey.Admin_Tenancy_IdentityProviders
        },
        {
            requiredRights: [
                "ADMINPORTAL.IdentityProviders.Setup"
            ],
            path: "/security-identity-providers/details",
            component: EditIdentityProvider,
            menuItemId: MenuItemKey.Admin_Tenancy_IdentityProviders
        },
        {
            requiredRights: [
                "ADMINPORTAL.IdentityProviders.Setup"
            ],
            path: "/security-identity-providers/details/:id",
            component: EditIdentityProvider,
            menuItemId: MenuItemKey.Admin_Tenancy_IdentityProviders
        },
        {
            requiredRights: [
                "ADMINPORTAL.Users.Setup"
            ],
            path: "/security-users",
            component: ListUsers,
            menuItemId: MenuItemKey.Admin_Tenancy_Users
        },
        {
            requiredRights: [
                "ADMINPORTAL.Users.Setup"
            ],
            path: "/security-users/userdetails",
            component: EditUser,
            menuItemId: MenuItemKey.Admin_Tenancy_Users
        },
        {
            requiredRights: [
                "ADMINPORTAL.Users.Setup"
            ],
            path: "/security-users/userdetails/:id",
            component: EditUser,
            menuItemId: MenuItemKey.Admin_Tenancy_Users
        },
        {
            requiredRights: [
                "ADMINPORTAL.Roles.Setup"
            ],
            path: "/security-roles/rolesdetails",
            component: EditRole,
            menuItemId: MenuItemKey.Admin_Tenancy_Roles
        },
        {
            requiredRights: [
                "ADMINPORTAL.Roles.Setup"
            ],
            path: "/security-roles/rolesdetails/:id",
            component: EditRole,
            menuItemId: MenuItemKey.Admin_Tenancy_Roles
        },
        {
            requiredRights: [
                "ADMINPORTAL.Roles.Setup"
            ],
            path: "/security-roles",
            component: ListRoles,
            menuItemId: MenuItemKey.Admin_Tenancy_Roles
        },
        {
            requiredRights: [
                "ADMINPORTAL.Delegates.Setup"
            ],
            path: "/admin/delegates/create",
            component: AdminCreateManyDelegates,
            menuItemId: MenuItemKey.Admin_Tenancy_Delegates
        },
        {
            requiredRights: ["ADMINPORTAL.AssetWorX+.Setup"],
            path: "/admin/nodes/:id/edit/",
            component: EditNode,
            props: { new: false },
            menuItemId: MenuItemKey.Admin_AssetsAndProcesses_NodeHierarchy,
        } as IRoute<IEditNodeProps>,
        {
            requiredRights: ["ADMINPORTAL.AssetWorX+.Setup"],
            path: "/admin/nodes/:id/children/new",
            component: EditNode,
            props: { new: true },
            menuItemId: MenuItemKey.Admin_AssetsAndProcesses_NodeHierarchy,
        } as IRoute<IEditNodeProps>,
        {
            requiredRights: ["ADMINPORTAL.AssetWorX+.Setup"],
            path: "/admin/nodes/tree-view",
            component: NodesTreeView,
            menuItemId: MenuItemKey.Admin_AssetsAndProcesses_NodeHierarchy,
        },
        {
            requiredRights: ["ADMINPORTAL.AssetWorX+.Setup"],
            path: "/admin/nodes/graph-view/:rootNodeId",
            component: NodesGraphView,
            menuItemId: MenuItemKey.Admin_AssetsAndProcesses_NodeHierarchy,
        },
        {
            requiredRights: ["ADMINPORTAL.Ontologies.Setup"],
            path: "/admin/ontologies/new",
            component: EditOntology,
            menuItemId: MenuItemKey.Admin_Platform_SystemOntologies,
        },
        {
            requiredRights: ["ADMINPORTAL.Ontologies.Setup"],
            path: "/admin/ontologies/:id/edit",
            component: EditOntology,
            menuItemId: MenuItemKey.Admin_Platform_SystemOntologies,
        },
        {
            requiredRights: ["ADMINPORTAL.Ontologies.Setup"],
            path: "/admin/ontologies",
            component: ListOntologies,
            menuItemId: MenuItemKey.Admin_Platform_SystemOntologies,
        },
        {
            requiredRights: ['ADMINPORTAL.Relationships.Setup'],
            path: "/admin/relationships/",
            component: ListRelationships,
            menuItemId: MenuItemKey.Admin_DataModel_Relationships,
        },
        {
            requiredRights: ['ADMINPORTAL.VirtualTreeviews.Setup'],
            path: "/admin/virtual-tree-views",
            component: ListVirtualTreeViews,
            menuItemId: MenuItemKey.Admin_AssetsAndProcesses_VirtualTreeViews,
        },
        {
            requiredRights: ['ADMINPORTAL.VirtualTreeviews.Setup'],
            path: "/admin/virtual-tree-views/new",
            component: EditVirtualTreeViews,
            menuItemId: MenuItemKey.Admin_AssetsAndProcesses_VirtualTreeViews,
        },
        {
            requiredRights: ['ADMINPORTAL.VirtualTreeviews.Setup'],
            path: "/admin/virtual-tree-views/:id/edit",
            component: EditVirtualTreeViews,
            menuItemId: MenuItemKey.Admin_AssetsAndProcesses_VirtualTreeViews,
        },
        {
            requiredRights: ['ADMINPORTAL.Relationships.Setup'],
            path: "/admin/relationships/new",
            component: EditRelationship,
            menuItemId: MenuItemKey.Admin_DataModel_Relationships,
        },
        {
            requiredRights: ['ADMINPORTAL.Relationships.Setup'],
            path: "/admin/relationships/:id/edit",
            component: EditRelationship,
            menuItemId: MenuItemKey.Admin_DataModel_Relationships,
        },
        {
            requiredRights: ['ADMINPORTAL.Packages.Setup'],
            path: "/admin/packages/",
            component: ListPackages,
            menuItemId: MenuItemKey.Admin_Platform_Packages,
        },
        {
            requiredRights: ['ADMINPORTAL.Packages.Setup'],
            path: "/admin/packages/new",
            component: EditPackage,
            menuItemId: MenuItemKey.Admin_Platform_Packages,
        },
        {
            requiredRights: ['ADMINPORTAL.Packages.Setup'],
            path: "/admin/packages/:id/edit",
            component: EditPackage,
            menuItemId: MenuItemKey.Admin_Platform_Packages,
        },
        {
            requiredRights: ["ADMINPORTAL.Entities.Setup"],
            path: "/admin/packages/:packageId/entities/new",
            component: EditEntity,
            menuItemId: MenuItemKey.Admin_Platform_Packages,
        },
        {
            requiredRights: ["ADMINPORTAL.Entities.Setup"],
            path: "/admin/packages/:packageId/entities/:entityId/edit",
            component: EditEntity,
            menuItemId: MenuItemKey.Admin_Platform_Packages,
        },
        {
            requiredRights: ["ADMINPORTAL.Attributes.Setup"],
            path: "/admin/packages/:packageId/attributes/new",
            component: EditAttribute,
            menuItemId: MenuItemKey.Admin_Platform_Packages,
        },
        {
            requiredRights: ["ADMINPORTAL.Attributes.Setup"],
            path: "/admin/packages/:packageId/attributes/:attributeId/edit",
            component: EditAttribute,
            menuItemId: MenuItemKey.Admin_Platform_Packages,
        },
        {
            requiredRights: ["ADMINPORTAL.Solutions.Setup"],
            path: "/admin/solutions",
            component: ListSolutions,
            menuItemId: MenuItemKey.Admin_Platform_Solutions,
        },
        {
            requiredRights: ["ADMINPORTAL.Solutions.Setup"],
            path: "/admin/solutions/new",
            component: EditSolution,
            menuItemId: MenuItemKey.Admin_Platform_Solutions,
        },
        {
            requiredRights: ["ADMINPORTAL.Solutions.Setup"],
            path: "/admin/solutions/:id/edit",
            component: EditSolution,
            menuItemId: MenuItemKey.Admin_Platform_Solutions,
        },
        {
            requiredRights: ['ADMINPORTAL.DataCredentials.Setup'],
            path: "/admin/data-hub-credentials/new",
            component: EditDataHubCredentials,
            menuItemId: MenuItemKey.Admin_DataExchange_Credentials,
        },
        {
            requiredRights: ['ADMINPORTAL.DataCredentials.Setup'],
            path: "/admin/data-hub-credentials/:id/edit",
            component: EditDataHubCredentials,
            menuItemId: MenuItemKey.Admin_DataExchange_Credentials,
        },
        {
            requiredRights: ['ADMINPORTAL.DataCredentials.Setup'],
            path: "/admin/data-hub-credentials",
            component: ListDataHubCredentials,
            menuItemId: MenuItemKey.Admin_DataExchange_Credentials,
        },
        {
            requiredRights: ['ADMINPORTAL.DataPublishers.Setup'],
            path: "/admin/data-hub-publishers/new",
            component: EditDataHubPublishers,
            menuItemId: MenuItemKey.Admin_DataExchange_Publishers,
        },
        {
            requiredRights: ['ADMINPORTAL.DataPublishers.Setup'],
            path: "/admin/data-hub-publishers/:id/edit",
            component: EditDataHubPublishers,
            menuItemId: MenuItemKey.Admin_DataExchange_Publishers,
        },
        {
            requiredRights: ['ADMINPORTAL.DataPublishers.Setup'],
            path: "/admin/data-hub-publishers",
            component: ListDataHubPublishers,
            menuItemId: MenuItemKey.Admin_DataExchange_Publishers,
        },
        {
            requiredRights: ['ADMINPORTAL.AssetWorX+.Setup'], // TBD: temporarily assigned AssetWorX+ permissions as there isn't an appropriate permission type for this
            path: "/admin/nodes/:nodeId/data-points/new",
            component: EditDataPoint,
            menuItemId: MenuItemKey.Admin_AssetsAndProcesses_NodeHierarchy, // same menuItemId as Nodes as it's only reachable from there
        },
        {
            requiredRights: ['ADMINPORTAL.AssetWorX+.Setup'], // TBD: temporarily assigned AssetWorX+ permissions as there isn't an appropriate permission type for this
            path: "/admin/nodes/:nodeId/data-points/:id/edit",
            component: EditDataPoint,
            menuItemId: MenuItemKey.Admin_AssetsAndProcesses_NodeHierarchy, // same menuItemId as Nodes as it's only reachable from there
        },
        {
            requiredRights: ["ADMINPORTAL.Tenancies.Setup"],
            path: "/admin/tenancies",
            component: ListTenancies,
            menuItemId: MenuItemKey.Admin_Platform_Tenancies,
        },
        {
            requiredRights: ["ADMINPORTAL.Tenancies.Setup"],
            path: "/admin/tenancies/new",
            component: EditTenancy,
            menuItemId: MenuItemKey.Admin_Platform_Tenancies,
        },
        {
            requiredRights: ["ADMINPORTAL.Tenancies.Setup"],
            path: "/admin/tenancies/:id/edit",
            component: EditTenancy,
            menuItemId: MenuItemKey.Admin_Platform_Tenancies,
        },
        {
            requiredRights: [
                "ADMINPORTAL.FileManagement.Setup"
            ],
            path: "/filemgmt/common",
            component: ListFiles,
            menuItemId: MenuItemKey.Admin_Platform_Files,
        },
        {
            requiredRights: ["ADMINPORTAL.SolutionEnablement.Setup"],
            path: "/admin/solutions/enablement",
            component: ViewSolutionEnablement,
            menuItemId: MenuItemKey.Admin_Tenancy_SolutionEnablement,
        },
    ];
}
